import React, { Component } from 'react';
import SelectPhotoDialog from 'containers/SelectPhotoDialog';
import { injectIntl } from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const changePictureTooltip = (
    <Tooltip id="selectPictureTooltip">
        Click to pick up a picture from gallery.
    </Tooltip>
);


class PhotoField extends Component {

    constructor(props) {
        super(props);

        this.selectPhoto = this.selectPhoto.bind(this);
        this.showSelectDialog = this.showSelectDialog.bind(this);
    }

    selectPhoto(photo) {
        let { websiteId } = this.props;
        this.props.input.onChange(window.origin + '/file/' + websiteId + '/' + photo._id);
    }

    showSelectDialog(e) {
        e.preventDefault();
        this.dialogSelectPhoto.getWrappedInstance().wrappedInstance.show();
    }

    render() {
        let { input, label, type, meta: { touched, error, warning }, autoFocus, websiteId, field, intl } = this.props;
        let hide = {
            display: 'none'
        }

        return (
            <span>
                {" "}
                {input.value ?
                    <span>
                        <OverlayTrigger placement="right" overlay={changePictureTooltip}>
                            <img src={input.value} className="gallery-photo" alt={"Select a photo"} onClick={this.showSelectDialog} />
                        </OverlayTrigger>
                        <i className="fa fa-minus-circle widget-delete-item" title="Remove Picture" onClick={() => {
                            this.props.input.onChange(null);
                        }}></i>

                    </span>

                    :
                    <span className="gallery-image-browse" onClick={this.showSelectDialog}><i className="fa fa-picture-o" />{" Choose..."}</span>
                }
                <input style={hide} ref="filePath" onChange={input.onChange} autoFocus={autoFocus} {...input} className="form-control" placeholder={label} type={type} />
                {touched &&
                    ((error && <span className="label label-danger">{error}</span>) ||
                        (warning && <span className="label label-warning">{warning}</span>))}

                <SelectPhotoDialog websiteId={websiteId} ref={instance => { this.dialogSelectPhoto = instance }} onOk={this.selectPhoto}
                    dialogTitle={"Select a photo"}
                    closeButtonLabel={"Close"}
                    submitButtonLabel={"Choose"} />
            </span>
        );
    }
}

export default injectIntl(PhotoField, { withRef: true });


// WEBPACK FOOTER //
// app/components/PhotoField.jsx